const base =  'https://prod.api.process-manager.dk/';

export const environment = {
  production: false,
  redirectHost: 'https://app.process-manager.dk/',
  api: base + 'api/',
  base: base
};
